import styled from 'styled-components'
import { Colors } from '~/styles'

const CardHeaderWrapper = styled.div`
  display: flex;
  padding: 24px;
  position: relative;
  align-items: ${(props) => props.alignItems || 'center'};
  justify-content: space-between;
`

const CardInfoWrapper = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  align-items: flex-start;
`

const CardInfoImage = styled.img`
  width: 115px;
  height: 115px;
  border-radius: 8px;
  object-fit: contain;
`

const CardInfoTitleWrapper = styled.span`
  gap: 8px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  justify-content: space-between;
`

const CardInfoTitle = styled.h2`
  color: ${Colors.black};
  font-size: ${(props) => props.fontSize};
  margin: 0;
`

const CardInfoTextWrapper = styled.div`
  width: 100%;
  display: grid;
  row-gap: 8px;
  column-gap: 16px;
  grid-template-columns: 1fr 1fr;
`

const CardInfoText = styled.p`
  font-size: ${(props) => props.fontSize};
  color: ${Colors.modalGrey};
  margin: 0;

  span {
    font-weight: 700;
    color: ${Colors.cancelTextColor};
  }
`

const CardBerthPills = styled.div`
  width: 125px;
  height: 40px;
  display: flex;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  align-items: center;
  border-radius: 24px;
  justify-content: center;
  background-color: ${(props) => props.backgroundColor || 'rgba(149, 193, 35, 0.3)'};
`

const CardInfoBerth = styled.p`
  color: ${Colors.tealBlue};
  margin: 0;
  font-size: 15px;
  font-weight: 800;
`

export default {
  CardInfoText,
  CardInfoImage,
  CardInfoTitle,
  CardInfoBerth,
  CardBerthPills,
  CardInfoWrapper,
  CardHeaderWrapper,
  CardInfoTextWrapper,
  CardInfoTitleWrapper,
}